import { render, staticRenderFns } from "./BarcodeOrderHeader.vue?vue&type=template&id=88b57032&scoped=true"
import script from "./BarcodeOrderHeader.vue?vue&type=script&lang=ts"
export * from "./BarcodeOrderHeader.vue?vue&type=script&lang=ts"
import style0 from "./BarcodeOrderHeader.vue?vue&type=style&index=0&id=88b57032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b57032",
  null
  
)

export default component.exports